<template>
  <div class="prescription-wrap">
    <div class="show-prescription-wrap">
      <!-- 循环showPrescritionArr数组start -->
      <div v-for="(item,index) in showPrescritionArr" :key="index" class="table-wrap">
        <div class="table-info">
          <span>处方编号：{{item.recipeNumber || item.recipeId}}</span>
          <span v-if="item.storageName">药房名称：{{item.storageName}}</span>
          <span>开方时间：{{item.time}}</span>
          <span>开方科室：{{item.deptName}}</span>
          <span>开方医生：{{item.deptUserName}}</span>
          <!-- <span>处方状态：{{item.statusText}}</span> -->
          <span :class="'statusText'+item.status">处方状态：{{item.statusText}}</span>

          <span>处方金额：{{item.moneyCount}}</span>
          <span v-if="$store.state.prvateConsultation.headerUserRest.status==2">操作</span>
          <div>
             <div @click="modifyRecipe(item)" class="modifyRecipe" v-if="item.status == 20">修改</div>
            <template v-if="$store.state.prvateConsultation.headerUserRest.status==2 && (item.status =='9' || item.status =='19')">
              <!-- <div @click="withdraw(item)" v-if="item.status == 10">修改</div> -->
              <!-- <div  @click="withdraw(item)">撤回</div> -->
              <div  @click="obsolete(item)">作废</div>
            </template>
            <template v-if="$store.state.prvateConsultation.headerUserRest.status==2 && item.status =='13'">
              <!-- <div style="background:#999"><span>撤回</span></div> -->
              <div style="background:#999"><span>作废</span></div>
            </template>
          </div>
        </div>
        <div class="table-header">
          <div
            v-for="(itemHead,indexHead) in item.touxinxi"
            :key="indexHead"
            :style="indexHead==0?'border-left: 1Px solid #EBEBEB;flex:2':''"
          >{{itemHead.title}}</div>
        </div>
        <div
          class="table-content"
          v-for="(neirongItem,neirongIndex) in item.neirong"
          :key="neirongIndex"
        >
          <div
            v-for="(childItem,childIndex) in neirongItem"
            :key="childIndex"
            v-show = "childItem.show"
            :style="childIndex==0?'border-left: 1Px solid #EBEBEB;flex:2':''"
            :title="childItem.value"
          >{{childItem.value}}</div>

        </div>
        <!-- {{item}} -->
         <p class="reason-p" v-if="item.reason">调方原因：{{item.reason}}</p>
      </div>
      <!-- 循环showPrescritionArr数组end -->
    </div>
    <div class="muban">
      <Button type="success" v-if="isshow" @click="hanldeTemple">引用模板</Button>
    </div>
    <div v-if="$store.state.prvateConsultation.headerUserRest.status==2"  class="create-prescription-wrap" @keydown="changeSuggestTabEvent">
      <div class="title-info">
        <p>开处方</p>
        <!-- 取药方式 -->
        <p class="drugtype">

          <ul v-for="(item,index) in drugTypeData" :key="index">
            <li :data-key="item.fetchDrugTypeID" @click="changeDrugType(item.fetchDrugTypeID)" :class="(formItemDrugType.type == item.fetchDrugTypeID ? 'active drugtype-li' : 'drugtype-li')">
               <span class="radio-span"></span>
               <span>{{item.desc}}</span>
            </li>
          </ul>
        </p>
        <div >
          <div @click="deleteInputData">删除</div>
          <div @click="showSaveModalFun">保存</div>
        </div>
      </div>
      <div class="title-shop" v-if="shopTrue">
         <div class="addshop">请选择药店</div>
          <p class="drugtypeshop">
            <ul v-for="(item,index) in yfArr" :key="index">
              <li :data-key="item.guid" @click="changeShop(item)" :class="(shop== item.guid ? 'active drugtype-li' : 'drugtype-li')">
                <span class="radio-span"></span>
                <span>{{item.name}}</span>
              </li>
            </ul>
          </p>
      </div>
      <div class="table-header">
        <div class="select-box">
          <input class="all-check-box" type="checkbox" @click="checkAllIndex">
        </div>
        <div
          v-for="(item,index) in columns"
          :key="index"
          style="border-top: 1Px solid #EBEBEB;"
          :style="item.key=='drugName'?'flex:2':''"
        >{{item.title}}</div>
      </div>
      <div class="table-content" v-for="(item,index) in inputData" :key="index"  >
        <div class="select-box">
          <input
            class="check-box-style"
            :data-inputdataindex="index"
            type="checkbox"
            @click="checkIndex"
          >
        </div>
        <div class="suggest-table-relative" v-for="(childItem,childIndex) in item" :key="childIndex" :style="'flex:'+childItem.flex+';'+(childItem.show==false?'display:none':'')">
          <input
            v-if="childItem.tagType=='input' && childItem.show"
            type="text"
            :class="childItem.key"
            v-model="childItem.value"
            :data-key="childItem.key"
            :data-index="index"
            @keydown.enter="enterEvent"
            @input="inputEvent"
            @focus="inputFocus"
            @blur="inputBlur"
            oninput = "if(this.dataset.key=='countFromDoctor'){ value = (/^[1-9]\d{0,2}$/).test(value) ? value:''} else if(this.dataset.key=='dosage'){value=(/^[0-9]+([.]{1}[0-9]{1,5})?$/).test(Number(value))? value:''}"
            :title="childItem.value"
          >

          <div v-else>
            <div v-if="childItem.key == 'retailPrice'">{{childItem.toFixedvalue}}</div>
            <div v-else>{{childItem.value}}</div>
           </div>
          <div v-if="childItem.key == 'dosage'">{{childItem.doseUnits}}</div>

        <!-- 药品联想弹出层 -->
        <div
          v-if="showSuggestTab && childItem.key === 'drugName' && index == inputIndex"
          class="suggest-table-wrap suggest-table-absolute suggest-table-drugName"
        >
          <div class="table-header">
            <div
              v-for="(item,index) in suggestTabHeadData"
              :key="index"
              :style="index==0?'border-left: 1Px solid #EBEBEB;border-top: 1Px solid #EBEBEB;':'border-top: 1Px solid #EBEBEB;'"
            >{{item.title}}</div>
          </div>
          <div>
          <div
            v-for="(item,index) in suggestTabData"
            :key="index"
            class="table-content"
            :style="index==checkedIndex?'background: #DAECFB':''"
            :data-index="index"
            @mouseenter="mouseenterEvent"
            @click="suggestTabDataClick"
          >
            <div
              v-for="(value,key) in item "
              :key="key"
              :style="key=='drugName'?'border-left: 1Px solid #EBEBEB;':''"
            >{{value}}</div>
          </div>
          </div>
          <div v-if="suggestTabData.length==0" style='border-left: 1Px solid #EBEBEB;border-right: 1Px solid #EBEBEB;border-bottom: 1Px solid #EBEBEB;'>无匹配信息</div>
        </div>
        <!-- 药品联想弹出层 -->
        <!-- 用法弹出层 -->
        <div
          v-if="showSuggestPop && childItem.key === 'drugRouteString' && index == inputIndex"
          class="suggest-pop-wrap  suggest-table-absolute"
          @click="suggestdrugRouteStringClick"
        >
          <div
            v-for="(item,index) in suggestdrugRouteStringData"
            :key="index"
            :style="index==checkedIndex?'background: #DAECFB':''"
            :data-index="index"
            @mouseenter="mouseenterEvent"
          >{{item.name}}</div>
        </div>
        <!-- 用法弹出层 -->
        <!-- 频次弹出层 -->
        <div
          v-if="showSuggestfrequenceCodeStringPop && childItem.key === 'frequenceCodeString' && index == inputIndex"
          class="suggest-pop-wrap  suggest-table-absolute"
          @click="suggestfrequenceCodeStringClick"
        >
          <div
            v-for="(item,index) in suggestfrequenceCodeStringData"
            :key="index"
            :style="index==checkedIndex?'background: #DAECFB':''"
            :data-index="index"
            @mouseenter="mouseenterEvent"
          >{{item.name}}</div>
        </div>
        <!-- 频次弹出层 -->
        </div>
      </div>
      <div class="total-price-style">合计：{{totalPrice}}元</div>
    </div>
    <div class="title-info print-wrap">
      <div>
        <div @click="print">打印</div>
      </div>
    </div>
    <!-- 保存确认框 -->
    <div v-if="showSaveModal" class="ivu-modal-wrap" style="z-index: 1008;background:rgba(55,55,55,.6);display:flex;justify-content:center;align-items:center" @click="showSaveModal=false">
      <div style="width:18vw;height:20vh;background:#fff;padding:3vh;border:1px solid #666">
        <div style="width:100%;height:100%;display:flex; flex-direction: column;justify-content: space-around">
          <p v-if="shopTrue" style="text-align:center;">(请确认药店是否正确)</p>
          <p style="text-align:center;">确认保存?</p>
          <div style="display:flex;justify-content:space-between;align-items:center;">
            <div style="display:flex;justify-content:center;align-items:center;width:6vw;height:4vh;color:#fff;border-radius:3px;background:#72BEFF;cursor: pointer;" @click="addInputData">
              确认
            </div>
            <div style="display:flex;justify-content:center;align-items:center;width:6vw;height:4vh;color:#fff;border-radius:3px;background:#aeb8c1;cursor: pointer;" @click="showSaveModal=false">
              取消
            </div>
          </div>
        </div>
      </div>
    </div>
  <!-- 保存确认框end -->

  <error-modal v-if="showErrorModal"  :errorList="errorList" @closeModal="showErrorModal=false"></error-modal>
  <!-- 撤回处方时弹窗 -->
  <Modal v-model="confirmed"  title="提示" @on-ok="confirmedOK">
      <div>是否确认撤回处方？</div>
  </Modal>
  <Modal  v-model="confirmedCover"  title="提示"  @on-ok="confirmedCoverOK">
      <div>撤回处方将覆盖现在开处方的内容，是否继续？</div>
  </Modal>

  <Modal
    v-model="drugtypeModel"
    class="drugtypeModel"
    :transfer="false"
    title="请选择患者取药方式，或发送消息让患者选择取药方式">
    <Form :model="formItemDrugType" :label-width="80">
      <FormItem>
        <RadioGroup v-model="formItemDrugType.type"  v-for="(item,index) in drugTypeData" :key="index">
          <Radio class="drugtype" :label="item.fetchDrugTypeID" >{{item.desc}}</Radio>
        </RadioGroup>
        </FormItem>
    </Form>
    <div slot="footer">
      <Button type="primary" @click="handleDrugType">确定</Button>
    </div>

  </Modal>
   <Drawer
      title="引用模板"
      :mask-closable="false"
      width="600"
      v-model="localVisible"
      @on-visible-change="handleDrawerChange"
      >
      <div class="Drawer">
        <!-- <div v-for="(item,index) in templateArr" :key="index" >
          <p>{{ item.name }}</p>

        </div> -->
                     <Collapse v-model="value1" accordion class="Collapse">
                <div
                  v-for="(item, index) in templateArr"
                  :key="item.templateId"
                >
                  <Panel>
                    <div class="checkbox-all">
                      <input
                        type="checkbox"
                        :id="item.templateId"
                        v-model="checkAll[index]"
                        v-on:click="handleCheckAll(index)"
                      />
                      <label :for="item.templateId">{{ item.templateName }}</label>
                    </div>
                    <div slot="content">
                      <div
                        class="checkbox-black"
                        v-for="items in item.prescription[0]['medicines']"
                        :key="items.templateId"
                      >
                        <input
                          type="checkbox"
                          :id="items.templateId"
                          :value="items.templateId"
                          v-model="checkAllGroup[index]"
                          v-on:click="handleCheckAllGroup(index, items)"
                        />
                        <label :for="items.drugAliasName">{{ items.drugName }}</label>
                      </div>
                    </div>
                  </Panel>
                </div>
              </Collapse>
      </div>
    </Drawer>
  </div>
</template>

<script>
import { api } from '@/services'
import { mapGetters, mapActions } from 'vuex'

import errorModal from '@/components/Error/eror'
export default {
  components: {
    errorModal
  },
  data () {
    return {
      // 取药方式
      formItemDrugType: {
        type: ''
      },
      localVisible: false,
      // drugTypeID: '',
      // 选择取药方式 弹窗
      drugtypeModel: false,
      // 取药方式列表
      drugTypeData: [],
      modifyRecipeID: '',
      // 报错提示层
      showErrorModal: false,
      // 撤回处方确认提示层
      confirmed: false,
      confirmedCover: false,
      // 撤回的处方信息
      confirmedObj: {},
      confirmedObjTempor: {},
      errorList: [],
      // 确认保存
      showSaveModal: false,
      // 合计金额
      totalPrice: '0.00',
      // 开处方头信息
      columns: [
        {
          title: '药品名称',
          key: 'drugName'
        },
        {
          title: '规格',
          key: 'drugSpec'
        },
        {
          title: '用量',
          key: 'dosage'
        },
        {
          title: '用法',
          key: 'drugRouteString'
        },
        {
          title: '频次',
          key: 'frequenceCodeString'
        },
        {
          title: '数量',
          key: 'countFromDoctor'
        },
        {
          title: '单位',
          key: 'packageUnits'
        },
        {
          title: '单价（元）',
          key: 'retailPrice'
        },
        {
          title: '金额（元）',
          key: 'totalCost'
        },
        {
          title: '用药天数',
          key: 'drugDays'
        },
        {
          title: '备注',
          key: 'remark'
        }
      ],
      // 展示处方数组
      showPrescritionArr: [
        {
          prescriptionId: '',
          reason: '',
          recipeId: '',
          time: '',
          deptName: '',
          deptUserName: '',
          statusText: '',
          moneyCount: '',
          touxinxi: [
            {
              title: '药品名称',
              key: 'drugName'
            },
            {
              title: '规格',
              key: 'drugSpec'
            },
            {
              title: '用量',
              key: 'dosage'
            },
            {
              title: '用法',
              key: 'drugRouteString'
            },
            {
              title: '频次',
              key: 'frequenceCodeString'
            },
            {
              title: '数量',
              key: 'countFromDoctor'
            },
            {
              title: '单位',
              key: 'packageUnits'
            },
            {
              title: '单价（元）',
              key: 'retailPrice'
            },
            {
              title: '金额（元）',
              key: 'totalCost'
            },
            {
              title: '用药天数',
              key: 'drugDays'
            },
            {
              title: '备注',
              key: 'remark'
            }
          ],
          neirong: [
            [
              {
                value: '',
                key: 'drugName',
                drugAliasName: '',
                tagType: 'input', // 是否是输入框
                show: true // 是否展示此字段
              },
              {
                value: '',
                key: 'drugSpec',
                tagType: 'div', // 是否是输入框
                show: true // 是否展示此字段
              },
              {
                value: '',
                doseUnits: '',
                key: 'dosage',
                tagType: 'input', // 是否是输入框
                show: true // 是否展示此字段
              },
              {
                value: '',
                key: 'drugRouteString',
                tagType: 'input', // 是否是输入框
                show: true // 是否展示此字段
              },
              {
                value: '',
                key: 'frequenceCodeString',
                tagType: 'input', // 是否是输入框
                show: true // 是否展示此字段
              },
              {
                value: '',
                key: 'countFromDoctor',
                tagType: 'input', // 是否是输入框
                show: true // 是否展示此字段
              },
              {
                value: '',
                key: 'packageUnits',
                tagType: 'div', // 是否是输入框
                show: true // 是否展示此字段
              },
              {
                value: '',
                key: 'retailPrice',
                tagType: 'div', // 是否是输入框
                show: true // 是否展示此字段
              },
              {
                value: '',
                key: 'totalCost',
                tagType: 'div', // 是否是输入框
                show: true // 是否展示此字段
              },
              {
                value: '',
                key: 'remark',
                tagType: 'input', // 是否是输入框
                show: true // 是否展示此字段
              },
              {
                value: '',
                key: 'drugDays',
                tagType: 'input', // 是否是输入框
                show: true // 是否展示此字段
              },
              {
                value: '',
                key: 'drugCode',
                tagType: 'input', // 是否是输入框
                show: false // 是否展示此字段
              },
              {
                value: '',
                key: 'doesPerUnit',
                tagType: 'input', // 是否是输入框
                show: false // 是否展示此字段
              },
              {
                value: '',
                key: 'doseUnits',
                tagType: 'input', // 是否是输入框
                show: false // 是否展示此字段
              },
              {
                value: '',
                key: 'drugRouteString',
                tagType: 'input', // 是否是输入框
                show: false // 是否展示此字段
              },
              {
                value: '',
                key: 'frequenceCodeString',
                tagType: 'input', // 是否是输入框
                show: false // 是否展示此字段
              },
              {
                value: '',
                key: 'firmId',
                tagType: 'input', // 是否是输入框
                show: false,
                drugForm: '',
                storage: '',
                drugIndicator: '',
                storageName: '',
                drugDosageform: '',
                inputCode: '',
                quantity: ''
              },
              {
                value: '',
                key: 'storageName',
                tagType: 'input', // 是否是输入框
                show: false,
                drugForm: '',
                storage: '',
                drugIndicator: '',
                storageName: '',
                drugDosageform: '',
                inputCode: '',
                quantity: ''
              }
            ]
          ]
        }
      ],
      // 开处方空数据
      baseData: [
        {
          value: '',
          key: 'drugName',
          drugAliasName: '',
          tagType: 'input', // 是否是输入框
          show: true,
          name: '药品名称',
          flex: 2,
          id: ''
        },
        {
          value: '',
          key: 'drugSpec',
          tagType: 'div', // 是否是输入框
          show: true,
          name: '规格',
          flex: 1
        },
        {
          value: '',
          key: 'dosage',
          tagType: 'input', // 是否是输入框
          show: true,
          name: '用量',
          flex: 1
        },
        {
          value: '',
          key: 'drugRouteString',
          tagType: 'input', // 是否是输入框
          show: true,
          name: '用法',
          flex: 1
        },
        {
          value: '',
          key: 'frequenceCodeString',
          tagType: 'input', // 是否是输入框
          show: true,
          name: '频次',
          flex: 1
        },
        {
          value: '',
          key: 'countFromDoctor',
          tagType: 'input', // 是否是输入框
          show: true,
          name: '数量',
          flex: 1
        },
        {
          value: '',
          key: 'packageUnits',
          tagType: 'div', // 是否是输入框
          show: true,
          name: '单位',
          flex: 1
        },
        {
          value: '',
          key: 'retailPrice',
          tagType: 'div', // 是否是输入框
          show: true,
          name: '单价',
          flex: 1
        },
        {
          value: '',
          key: 'totalCost',
          tagType: 'div', // 是否是输入框
          show: true,
          name: '金额',
          flex: 1
        },
        {
          value: '',
          key: 'drugDays',
          tagType: 'input', // 是否是输入框
          show: true,
          name: '用药天数',
          flex: 1
        },
        {
          value: '',
          key: 'remark',
          tagType: 'input', // 是否是输入框
          show: true,
          name: '备注',
          flex: 1
        },
        {
          value: '',
          key: 'drugCode',
          tagType: 'div', // 是否是输入框
          show: false,
          name: '药品编码',
          flex: 1
        },
        {
          value: '',
          key: 'doesPerUnit',
          tagType: 'div', // 是否是输入框
          show: false,
          name: '最小单位剂量',
          flex: 1
        },
        {
          value: '',
          key: 'doseUnits',
          tagType: 'div', // 是否是输入框
          show: false,
          name: '剂量单位',
          flex: 1
        },
        {
          value: '',
          key: 'drugRouteString',
          tagType: 'div', // 是否是输入框
          show: false,
          name: '用法key',
          flex: 1
        },
        {
          value: '',
          key: 'frequenceCodeString',
          tagType: 'div', // 是否是输入框
          show: false,
          name: '频次key',
          flex: 1
        },
        {
          value: '',
          key: 'firmId',
          tagType: 'div', // 是否是输入框
          show: false,
          name: '药品厂家',
          flex: 1,
          drugForm: '',
          storage: '',
          drugIndicator: '',
          storageName: '',
          drugDosageform: '',
          inputCode: '',
          quantity: ''
        }
      ],
      // 临时存储 联想数据
      tempSuggestData: [],
      // 需要添加的处方信息
      inputData: [],
      // 选中的药品数组(全选，单选)
      checkedIndexArr: [],
      // 药品名称联想表头数据
      suggestTabHeadData: [
        {
          title: '药品名称',
          key: 'drugName'
        },
        {
          title: '药品编号',
          key: 'drugCode'
        },
        //  {
        //    title: '厂家',
        //    key: 'firmId'
        //  },
        {
          title: '规格',
          key: 'drugSpec'
        },
        {
          title: '频次',
          key: 'frequenceCodeString'
        },
        {
          title: '用法',
          key: 'drugRouteString'
        },
        {
          title: '用量',
          key: 'dosage'
        },
        {
          title: '单位',
          key: 'packageUnits'
        },
        {
          title: '单价',
          key: 'retailPrice'
        }
      ],
      // 药品名称联想假数据
      suggestTabData: [],
      // 用法假数据
      suggestdrugRouteStringData: [],
      // 频次假数据
      suggestfrequenceCodeStringData: [],

      // suggestdrugRouteStringDataCache:[],
      // suggestfrequenceCodeStringDataCache:[],
      // 弹层数据length
      popDataLength: 0,
      // 输入药品名称哪一个行的index
      inputIndex: 0,
      // 是否展示联想药品表格
      showSuggestTab: false,
      // 是否展示用法的弹层
      showSuggestPop: false,
      // 是否展示频次的弹层
      showSuggestfrequenceCodeStringPop: false,
      // 选中的联想药品的index
      checkedIndex: 0,
      // 联想药品层定位y
      suggestTabDataTop: 0,
      // 联想药品层定位x
      suggestTabDataLeft: 0,
      // 延迟请求
      timer: false,
      yfArr: [],
      shop: '',
      shopName: '',
      shopTrue: false,
      isshow: false,
      guidArr: ['b91df6e4-8e65-4779-a64e-7483549fad93', '11b2aae1-63fc-44aa-b825-8b02e3f86fca', '1f403d24-cac0-47d9-9237-2a299cfc4461', '459f813d-b1f3-4fc0-88d2-05eac532b2f0'],
      searchKey: '',
      pageSize: 10,
      pageNum: 1,
      templateArr: [],
      value1: '',
      checkAll: [],
      checkAllGroup: [],
    }
  },
  methods: {
    // 获取焦点，改变当前输入行index
    inputFocus (e) {
      this.inputIndex = e.target.dataset.index
    },
    // 失去焦点事件
    inputBlur (e) {
      if (e.target.dataset.key == 'dosage') {
        let value = e.target.value
        let tempValue = value
        if (value == '0' || value == '0.') {
          e.target.value = ''
          return
        }
        if (value.toString().indexOf('.') != -1) {
          let i = value.length - 1
          for (i; i > 0; i--) {
            if (value[i] == '0' || value[i] == '.') {
              tempValue = value.substring(0, i)
            } else {
              break
            }
          }
          e.target.value = tempValue
        }
      }
      if (e.target.dataset.key === 'drugRouteString') {
        // hock自己输入的用法
        setTimeout(() => {
          if (!this.inputData[e.target.dataset.index][14].lock) {
            e.target.value = ''
            this.inputData[e.target.dataset.index][3].value = ''
            console.log(e.target.value)
          }
          this.inputData[e.target.dataset.index][14].lock = false
          //  console.log(this.columns)
          //   console.log(e.target.dataset)
          // console.log(this.inputData[e.target.dataset.index][13].lock)
        }, 200)
      }
      //
    },
    // 撤回确认
    confirmedOK () {
      if (this.inputData[0][0].value !== '') {
        this.confirmedCover = true
      } else {
        this.confirmedObj = this.confirmedObjTempor
        this.withdrawRequest()
      }
    },
    confirmedCoverOK () {
      this.confirmedObj = this.confirmedObjTempor
      this.withdrawRequest()
    },
    withdraw (obj) {
      this.confirmed = true
      this.confirmedObjTempor = obj
    },
    // 撤回确认后的请求
    withdrawRequest (obj = this.confirmedObj) {
      api
        .adminOnlineRecipeRecall({
          data: {
            params: {
              recipeId: obj.recipeId
            }
          }
        })
        .then(res => {
          if (res.code == '0') {
            this.onlineRecipeList(() => {
              // 输入框填充撤回数据
              this.setInputData(obj)
            })
          }
        })
    },
    // 撤回时设置InputData
    setInputData (obj) {
      let Arr = obj.neirong.map((item2, index) => {
        let nArr = []
        let baseData = _.cloneDeep(this.baseData)

        item2.forEach((element, index) => {
          // 用量有单位处理
          if (index == 2) {
            element.value = parseFloat(element.value)
          }
          nArr.push(Object.assign(baseData[index], element))
        })
        return nArr
      })
      if (Arr.length > 0) {
        this.inputData = [...Arr]
      } else {
        this.inputData = [_.cloneDeep(this.baseData)]
      }
      this.confirmedObj = obj
    },
    // 修改处方
    modifyRecipe (obj) {
      this.modifyRecipeID = obj.prescriptionId
      this.confirmedObjTempor = obj
      this.setInputData(obj)
    },

    // 作废
    obsolete (obj) {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>是否确认作废</p>',
        onOk: () => {
          api
            .adminOnlineRecipeDelete({
              data: {
                params: {
                  recipeId: obj.recipeId
                }
              }
            })
            .then(res => {
              // if (res.code == '0') {
              //   this.onlineRecipeList()
              // }
              this.onlineRecipeList()
            })
        },
        onCancel: () => {
        }
      })
    },
    // 获取取药方式列表
    handleIsPrescribe () {
      api
        .queryFetchDrugType({
          data: {
            params: {}
          }
        })
        .then(res => {
          this.drugTypeData = _.cloneDeep(res.data.list)
        })
    },
    // 修改取药方式
    changeDrugType (data) {
      this.$Modal.confirm({
        content: '切换药库将清除未开方的药品，是否继续？',
        onOk: () => {
          this.formItemDrugType.type = data
          this.inputData = [_.cloneDeep(this.baseData)]
        },
        onCancel: () => {
          // this.$Message.info('取消了')
        }
      })
    },
    changeShop (data) {
      this.$Modal.confirm({
        content: '切换药库将清除未开方的药品，是否继续？',
        onOk: () => {
          this.shop = data.guid
          this.shopName = data.name
          this.inputData = [_.cloneDeep(this.baseData)]
        },
        onCancel: () => {
          // this.$Message.info('取消了')
        }
      })
    },
    // 提交取药方式
    handleDrugType () {
      if (!this.formItemDrugType.type) {
        this.$Message.error('请选择取药方式')
        return false
      }
      // debugger
      api
        .selectFetchDrugType({
          data: {
            params: {
              fetchDrugTypeID: this.formItemDrugType.type,
              orderId: this.$store.state.prvateConsultation.orderId
            }
          }
        })
        .then(res => {
          if (res.code === 0) {
            this.drugtypeModel = false
            this.$Message.success('提交取药方式成功')
          }
        })
    },
    // 处方方列表
    onlineRecipeList (fn) {
      if (this.$store.state.prvateConsultation.orderId != '') {
        api
          .adminOnlineRecipeList({
            data: {
              params: {
                orderId: this.$store.state.prvateConsultation.orderId
              }
            }
          })
          .then(res => {
            if (res.code === 0) {
              // this.$store.commit('prvateConsultation/setIsPrescribe', res.data.list.length)
              Object.assign(this.$data, this.$options.data())

              res.data.list.map((x, index) => {
                let touxinxi = this.showPrescritionArr[0].touxinxi
                let neirong = []
                x.recipeArray.map((recipe, childIndex) => {
                  recipe.countFromDoctor = (recipe.countFromDoctor || recipe.frequencyCount)
                  let arr = _.cloneDeep(this.showPrescritionArr[0].neirong[0])
                  neirong.push(arr)
                  this.$set(neirong[childIndex][0], 'value', recipe.drugName)
                  if (recipe.drugSpec) {
                    // this.$set(neirong[childIndex][1], 'value', recipe.drugSpec.replace(/[\u4e00-\u9fa5]|[(]|[)]/g, ''))
                    this.$set(neirong[childIndex][1], 'value', recipe.drugSpec)
                  }
                  this.$set(
                    neirong[childIndex][2],
                    'value',
                    recipe.dosage + recipe.doseUnits
                  )
                  this.$set(neirong[childIndex][2], 'doseUnits', recipe.doseUnits)
                  this.$set(neirong[childIndex][3], 'value', recipe.drugRoute)
                  this.$set(
                    neirong[childIndex][4],
                    'value',
                    recipe.frequenceCode
                  )
                  this.$set(
                    neirong[childIndex][5],
                    'value',
                    recipe.countFromDoctor
                  )
                  this.$set(
                    neirong[childIndex][6],
                    'value',
                    recipe.packageUnits
                  )
                  // this.$set(neirong[childIndex][7], 'value', (Math.round(recipe.retailPrice * 100) / 100).toFixed(2))
                  // this.$set(neirong[childIndex][7], 'toFixedvalue', (Math.round(recipe.retailPrice * 100) / 100).toFixed(2))
                  this.$set(neirong[childIndex][7], 'value', recipe.retailPrice)
                  this.$set(neirong[childIndex][7], 'toFixedvalue', recipe.retailPrice)
                  // this.$set(
                  //   neirong[childIndex][8],
                  //   'value',
                  //   (recipe.totalCost / 100).toFixed(2)
                  // )
                  this.$set(
                    neirong[childIndex][8],
                    'value',
                    (Math.round(recipe.retailPrice * recipe.countFromDoctor * 100) / 100).toFixed(2)
                  )
                  // console.log(Math.round(recipe.retailPrice * recipe.countFromDoctor * 100) / 100).toFixed(2)
                  this.$set(neirong[childIndex][9], 'value', recipe.drugDays)
                  this.$set(neirong[childIndex][10], 'value', recipe.remark)
                  this.$set(neirong[childIndex][11], 'value', recipe.drugCode)
                  this.$set(neirong[childIndex][12], 'value', recipe.doesPerUnit)
                  this.$set(neirong[childIndex][13], 'value', recipe.doseUnits)
                  this.$set(neirong[childIndex][14], 'value', recipe.drugRouteString)
                  this.$set(neirong[childIndex][15], 'value', recipe.frequenceCodeString)
                  this.$set(neirong[childIndex][16], 'value', recipe.firmId)
                  this.$set(neirong[childIndex][17], 'value', recipe.storageName)
                })
                this.$set(this.showPrescritionArr, index, {
                  recipeId: x.recipeId,
                  time: x.time,
                  moneyCount: x.moneyCount,
                  statusText: x.statusText,
                  status: x.status,
                  deptName: this.$store.state.auth.info.deptName,
                  deptUserName: this.$store.state.auth.info.userName,
                  touxinxi: touxinxi,
                  neirong: neirong,
                  recipeNumber: x.recipeNumber,
                  reason: x.reason,
                  prescriptionId: x.prescriptionId,
                  storageName: x.recipeArray[0].storageName
                })
              })
              fn && fn()
              this.init(this.inputData)
              if (this.$store.state.prvateConsultation.headerUserRest.show_getDrug_type == 1 && this.$store.state.prvateConsultation.headerUserRest.status != 3) {
                this.handleIsPrescribe()
                if (this.guidArr.includes(this.$store.state.auth.info.allHospitalGuid)) {
                  this.getShop()
                  this.shopTrue = true
                }
                this.$set(this.formItemDrugType, 'type', this.$store.state.prvateConsultation.headerUserRest.fetchDrugTypeID)
                if (res.data.list.length === 0 && !this.formItemDrugType.type) {
                  this.drugtypeModel = true
                }
                // 患者选择了取药方式 并且是快递
                if (this.$store.state.prvateConsultation.headerUserRest.fetchDrugTypeName.indexOf('快递') > -1) {
                  this.$Modal.warning({
                    title: '提示',
                    content: '患者选择的取药方式为快递，需要确认是院内还是院外'
                  })
                }
              }
            }
          })
      }
    },
    // 回车事件
    enterEvent (e) {
      let mark = e.target.dataset.key
      let index = e.target.dataset.index // 哪一行输入框的index
      if (mark == 'remark') {
        //  if (this.inputData.length >= 5) return;
        for (let i of this.inputData[index]) {
          if (
            (i.value == '' || i.value == undefined) &&
            i.key != 'remark' &&
            i.key != 'drugDays' &&
            i.show
          ) {
            this.$Message.error('请补全当前行' + i.name + '信息')
            return
          }
        }
        let tempObj = _.cloneDeep(this.baseData)
        let dom = document.getElementsByClassName('all-check-box')[0]
        this.inputData.push(tempObj)
        if (this.checkedIndexArr.length === this.inputData.length) {
          dom.checked = true
        } else {
          dom.checked = false
        }
        this.$nextTick(() => {
          this.jumpFocus(Number(index) + 1, 'drugName')
        })
      } else if (mark == 'drugName') {
        this.inputIndex = index
        this.suggestTabDataClick()
        this.showSuggestTab = false
        // 跳转到用量输入框
        this.jumpFocus(index, 'dosage')
      } else if (mark == 'dosage') {
        // 跳转到用法
        this.jumpFocus(index, 'drugRouteString')
      } else if (mark == 'drugRouteString') {
        // console.log(this.suggestdrugRouteStringData)
        this.inputData[index][3].value = this.suggestdrugRouteStringData[this.checkedIndex].name
        this.inputData[index][14].value = this.suggestdrugRouteStringData[this.checkedIndex].value
        this.jumpFocus(index, 'frequenceCodeString')
        this.inputData[index][14].lock = true
      } else if (mark == 'frequenceCodeString') {
        this.suggestfrequenceCodeStringClick()
        this.jumpFocus(index, 'countFromDoctor')
      } else if (mark == 'countFromDoctor') {
        this.jumpFocus(index, 'remark')
      }
      this.closeAllPop()
      this.totalPriceFun()
    },
    // 鼠标移入事件
    mouseenterEvent (e) {
      this.checkedIndex = e.target.dataset.index
    },
    // 联想药品层鼠标点击事件
    suggestTabDataClick () {
      // console.log(111)
      let index = this.inputIndex // 哪一行输入框的index
      let tempSuggestDataIndex = this.tempSuggestData[this.checkedIndex]
      this.inputData[index][0].value = tempSuggestDataIndex['drugName']
      this.inputData[index][0].drugAliasName = tempSuggestDataIndex['drugAliasName']
      this.inputData[index][0].id = tempSuggestDataIndex['id']
      // this.inputData[index][1].value = tempSuggestDataIndex['drugSpec'].replace(/[\u4e00-\u9fa5]|[(]|[)]/g, '') // 去除产商中文
      this.inputData[index][1].value = tempSuggestDataIndex['drugSpec']

      this.inputData[index][1].value2 = tempSuggestDataIndex['drugSpec'] // 实际传的
      this.inputData[index][2].value = tempSuggestDataIndex['dosage']
      this.inputData[index][2].doseUnits = tempSuggestDataIndex['doseUnits']
      this.inputData[index][3].value = tempSuggestDataIndex['drugRouteString']
      this.inputData[index][4].value = tempSuggestDataIndex['frequenceCodeString']
      this.inputData[index][5].value = 1
      this.inputData[index][6].value = tempSuggestDataIndex['packageUnits']
      // this.inputData[index][7].value = (Math.round(tempSuggestDataIndex['retailPrice'] * 1 * 100) / 100).toFixed(2)
      // this.inputData[index][7].value2 = tempSuggestDataIndex['retailPrice']
      // this.inputData[index][7].toFixedvalue = (Math.round(tempSuggestDataIndex['retailPrice'] * 1 * 100) / 100).toFixed(2)
      // this.inputData[index][8].value = (Math.round(tempSuggestDataIndex['retailPrice'] * 1 * 100) / 100).toFixed(2)
      this.inputData[index][7].value = tempSuggestDataIndex['retailPrice']
      this.inputData[index][7].value2 = tempSuggestDataIndex['retailPrice']
      this.inputData[index][7].toFixedvalue = tempSuggestDataIndex['retailPrice']
      this.inputData[index][8].value = tempSuggestDataIndex['retailPrice']

      this.inputData[index][11].value = tempSuggestDataIndex['drugCode']
      this.inputData[index][12].value = tempSuggestDataIndex['doesPerUnit']
      this.inputData[index][13].value = tempSuggestDataIndex['doseUnits']
      this.inputData[index][14].value = tempSuggestDataIndex['drugRoute']
      this.inputData[index][15].value = tempSuggestDataIndex['frequenceCode']
      this.inputData[index][16].value = tempSuggestDataIndex['firmId']
      this.inputData[index][16].drugForm = tempSuggestDataIndex['drugForm']
      this.inputData[index][16].storage = tempSuggestDataIndex['storage']
      this.inputData[index][16].drugIndicator = tempSuggestDataIndex['drugIndicator']
      this.inputData[index][16].storageName = tempSuggestDataIndex['storageName']
      this.inputData[index][16].drugDosageform = tempSuggestDataIndex['drugDosageform']
      this.inputData[index][16].inputCode = tempSuggestDataIndex['inputCode']
      this.inputData[index][16].quantity = tempSuggestDataIndex['quantity']

      this.inputData[index][14].lock = true
      this.closeAllPop()
      this.totalPriceFun()
      // 跳转到用量输入框
      this.jumpFocus(this.inputIndex, 'dosage')
    },
    // 用法点击事件
    suggestdrugRouteStringClick () {
      this.inputData[this.inputIndex][14].lock = true
      this.inputData[this.inputIndex][3].value = this.suggestdrugRouteStringData[this.checkedIndex].value
      this.inputData[this.inputIndex][14].value = this.suggestdrugRouteStringData[this.checkedIndex].name
      this.closeAllPop()
      this.jumpFocus(this.inputIndex, 'frequenceCodeString')
    },
    // 频次点击事件
    suggestfrequenceCodeStringClick () {
      this.inputData[this.inputIndex][4].value = this.suggestfrequenceCodeStringData[this.checkedIndex].value
      this.inputData[this.inputIndex][15].value = this.suggestfrequenceCodeStringData[this.checkedIndex].name
      this.closeAllPop()
      this.jumpFocus(this.inputIndex, 'countFromDoctor')
    },
    // 设置各种弹层定位
    setSuggestTabDataTop (index, name) {
      let domArr = []
      for (let i = 0; i < document.all.length; i++) {
        if (document.all[i].type == 'text') {
          domArr.push(document.all[i])
        }
      }

      for (let m = 0; m < domArr.length; m++) {
        if (
          domArr[m].dataset.index === index &&
          domArr[m].dataset.key === name
        ) {
          let clientHeight = document.documentElement.clientHeight
          if (
            domArr[m].getBoundingClientRect().y +
            (domArr[m].getBoundingClientRect().height + 1) * 7 >
            clientHeight
          ) {
            this.suggestTabDataTop =
              domArr[m].getBoundingClientRect().y -
              (domArr[m].getBoundingClientRect().height + 1) * 5
            this.suggestTabDataLeft = domArr[m].getBoundingClientRect().x - 1
          } else {
            this.suggestTabDataTop =
              domArr[m].getBoundingClientRect().y +
              domArr[m].getBoundingClientRect().height +
              1
            this.suggestTabDataLeft = domArr[m].getBoundingClientRect().x - 1
          }
          break
        }
      }
    },
    // 用法联想
    suggestTabDataInit (keyword) {
      let i = 0
      let j = 0
      this.suggestdrugRouteStringData = []
      this.suggestfrequenceCodeStringData = []
      console.log(this.suggestdrugRouteStringDataCache)
      this.suggestdrugRouteStringDataCache.map((item, index) => {
        if (item.py && item.py.indexOf(keyword) != -1) {
          this.$set(this.suggestdrugRouteStringData, i, item)
          i++
        } else if (item.value && item.value.indexOf(keyword) != -1) {
          this.$set(this.suggestdrugRouteStringData, i, item)
          i++
        }
        this.popDataLength = this.suggestdrugRouteStringData.length
        //  console.log(111)
      })

      this.suggestfrequenceCodeStringDataCache.map((item, index) => {
        if (item.py && item.py.indexOf(keyword) != -1) {
          this.$set(this.suggestfrequenceCodeStringData, j, item)
          j++
        } else if (item.sx && item.sx.indexOf(keyword) != -1) {
          this.$set(this.suggestfrequenceCodeStringData, j, item)
          j++
        }
        this.popDataLength = this.suggestfrequenceCodeStringData.length
      })
    },
    // 用法联想列表下发
    suggestTabDataGet () {
      api.getHospitalConfigInfo({
        data: {
          params: {
            config_id: 319,
            hospital_guid: this.$store.state.auth.info.allHospitalGuid,
            card_id: this.$store.state.prvateConsultation.headerUserRest
              .cardId
          }
        }
      })
        .then(res => {
          if (res.code == '0') {
            // this.$set(this.suggestdrugRouteStringDataCache,res.data.info.drugRoute)
            //  this.suggestdrugRouteStringDataCache =  _.cloneDeep(res.data.info.drugRoute)
            //  this.suggestfrequenceCodeStringDataCache =  _.cloneDeep(res.data.info.drugFrequency)
            this.$store.commit('prvateConsultation/setsuggestdrugDataCache', res.data.info)
            //  debugger
          }
        })
    },

    hospitalConfigDelay: function (keyword, i) {
      let that = this
      // if (this.timer) {
      //   clearInterval(this.timer)
      // }
      that.suggestTabDataInit(keyword)
    },
    // 药品名称 延时请求处理
    delayRequest: function (newValue, i) {
      var that = this
      var j = 10

      if (that.formItemDrugType.type == null && this.$store.state.prvateConsultation.headerUserRest.show_getDrug_type == 1) {
        this.$Message.error('请选择取药方式')
        return false
      }
      this.suggestTabData = []
      if (this.timer) {
        clearInterval(this.timer)
      }
      this.timer = setInterval(function () {
        ++i
        if (i == j) {
          api
            .newMedicineSearch({
              data: {
                params: {
                  keyword: newValue.split("'").join(""),
                  page_no: 1,
                  fetchDrugTypeID: that.formItemDrugType.type,
                  storage: that.shop
                }
              }
            })
            .then(res => {
              if (res.code == '0') {

                res.data.medicine.map((v, i) => {
                  if (that.shop) {
                    v.storage = that.shop
                    v.storageName = that.shopName
                  }
                  that.$set(that.suggestTabData, i, {
                    drugName: v.drugName,
                    drugCode: v.drugCode,
                    //  firmId : v.firmId,
                    drugSpec: v.drugSpec,
                    frequenceCodeString: v.frequenceCodeString,
                    drugRouteString: v.drugRouteString,
                    dosage: v.dosage,
                    packageUnits: v.packageUnits,
                    retailPrice: v.retailPrice
                  })
                  that.popDataLength = that.suggestTabData.length
                })
                console.log(res.data.medicine, 345)
                that.tempSuggestData = res.data.medicine
              }
            })

          clearInterval(that.timer)
        }
      }, 100)
    },
    // 输入事件
    inputEvent (e) {
      let mark = e.target.dataset.key
      let value = e.target.value
      let index = e.target.dataset.index // 哪一行输入框的index
      this.inputIndex = index
      this.closeAllPop()
      if (mark == 'drugName') {
        if (value != '') {
          this.checkedIndex = 0
          this.showSuggestTab = true
          this.setSuggestTabDataTop(index, 'drugName')
          this.inputData[index].map(item => {
            if (item.key != 'drugName') {
              item.value = ''
            }
          })
          this.delayRequest(value, 0)
          this.totalPriceFun()
        } else {
          this.checkedIndex = 0
          this.showSuggestTab = false
        }
      } else if (mark == 'drugRouteString') {
        if (value != '') {
          this.checkedIndex = 0
          this.showSuggestPop = true
          this.popDataLength = this.suggestdrugRouteStringData.length

          this.setSuggestTabDataTop(index, 'drugRouteString')
          this.hospitalConfigDelay(value, 0)
        } else {
          this.checkedIndex = 0
          this.showSuggestPop = false
        }
      } else if (mark == 'frequenceCodeString') {
        if (value != '') {
          this.checkedIndex = 0
          this.showSuggestfrequenceCodeStringPop = true
          this.setSuggestTabDataTop(index, 'frequenceCodeString')
          this.popDataLength = this.suggestfrequenceCodeStringData.length
          this.hospitalConfigDelay(value, 0)
        } else {
          this.checkedIndex = 0
          this.showSuggestfrequenceCodeStringPop = false
        }
      } else if (mark == 'countFromDoctor') {
        if (value != '') {
          let vv = (Math.round(this.inputData[this.inputIndex][7].value * value * 100) / 100).toFixed(2)
          this.inputData[this.inputIndex][8].value = vv
          this.totalPriceFun()
        } else {
          this.checkedIndex = 0
          this.showSuggestfrequenceCodeStringPop = false
        }
      }
    },
    // 选择联想的药品信息
    changeSuggestTabEvent (e) {
      let mark = e.target.dataset.key
      if (mark == 'drugRouteString') {
        this.popDataLength = this.suggestdrugRouteStringData.length
        //  console.log(this.suggestdrugRouteStringData.length)
      }

      if (
        this.showSuggestTab ||
        this.showSuggestPop ||
        this.showSuggestfrequenceCodeStringPop
      ) {
        if (e.code == 'ArrowDown') {
          this.checkedIndex = ++this.checkedIndex
          if (this.checkedIndex > this.popDataLength - 1) {
            this.checkedIndex = 0
          }
        } else if (e.code == 'ArrowUp') {
          this.checkedIndex = --this.checkedIndex
          if (this.checkedIndex < 0) {
            this.checkedIndex = this.popDataLength - 1
          }
        }
        let itemIndex = this.checkedIndex
        // console.log(document
        // .querySelector(`.table-content[data-index='${itemIndex}']`))
        // document.querySelector(`.table-content[data-index='${itemIndex}']`) &&
        //   document
        //     .querySelector(`.table-content[data-index='${itemIndex}']`)
        //     .scrollTop()
        document.querySelector(`.suggest-table-absolute`).scrollTop = 25 * this.checkedIndex
      }
    },
    // 全选
    checkAllIndex () {
      let dom = document.getElementsByClassName('all-check-box')[0]
      let inputDom = document.getElementsByClassName('check-box-style')
      if (dom.checked) {
        this.checkedIndexArr = []
        this.inputData.map((item, index) => {
          this.checkedIndexArr.push(index)
        })
      } else {
        this.checkedIndexArr = []
      }
      for (let i = 0; i < inputDom.length; i++) {
        inputDom[i].checked = dom.checked
      }
    },
    // 单选
    checkIndex (e) {
      let index = Number(e.target.dataset.inputdataindex)
      let dom = document.getElementsByClassName('all-check-box')[0]
      let inputDom = document.getElementsByClassName('check-box-style')[index]
      if (inputDom.checked) {
        this.checkedIndexArr.push(index)
      } else {
        this.checkedIndexArr.map((item, i) => {
          if (item == index) {
            this.checkedIndexArr.splice(i, 1)
          }
        })
      }
      if (this.checkedIndexArr.length === this.inputData.length) {
        dom.checked = true
      } else {
        dom.checked = false
      }
    },
    // 删除选择的处方
    deleteInputData () {
      let inputDom = document.getElementsByClassName('check-box-style')
      let dom = document.getElementsByClassName('all-check-box')[0]
      let tempArr = _.cloneDeep(this.inputData)
      this.checkedIndexArr.map((item, index) => {
        tempArr[item] = ''
      })
      this.inputData = []
      tempArr.map(item => {
        if (item !== '') {
          this.inputData.push(item)
        }
      })
      for (let i = 0; i < inputDom.length; i++) {
        inputDom[i].checked = false
      }
      this.checkedIndexArr = []
      if (this.inputData.length === 0) {
        let tempObj = _.cloneDeep(this.baseData)
        this.inputData.push(tempObj)
        dom.checked = false
      }
      this.totalPriceFun()
    },
    // 展示保存提示框
    showSaveModalFun () {
      for (let m = 0; m < this.inputData.length; m++) {
        for (let n of this.inputData[m]) {
          if (
            n.show &&
            n.key != 'remark' &&
            (n.value == '' || n.value == undefined)
          ) {
            this.$Message.error(n.name + '必填，请填写后提交')
            return
          }
        }
      }
      this.showSaveModal = true
    },
    // 发送处方信息
    addInputData (e) {
      e.stopPropagation()
      let medicineInfoList = []
      this.inputData.map(item => {
        let obj = {
          id: item[0].id,
          drugName: item[0].value,
          drugAliasName: item[0].drugAliasName,
          drugSpec: item[1].value,
          dosage: item[2].value,
          drugRoute: item[3].value,
          frequenceCode: item[4].value,
          countFromDoctor: item[5].value,
          packingNumber: item[5].value,
          frequencyCount: item[5].value,
          packageUnits: item[6].value,
          retailPrice: item[7].value,
          moneyCount: item[8].value,
          drugDays: item[9].value,
          remark: item[10].value,
          drugCode: item[11].value,
          doesPerUnit: item[12].value,
          doseUnits: item[13].value,
          drugRouteString: item[14].value,
          frequenceCodeString: item[15].value,
          firmId: item[16].value,
          drugForm: item[16].drugForm,
          drugIndicator: item[16].drugIndicator,
          inputCode: item[16].inputCode,
          quantity: item[16].quantity,
          storage: item[16].storage,
          storageName: item[16].storageName,
          priceUnit: '元'
        }
        medicineInfoList.push(obj)
      })
      // if (this.modifyRecipeID) {
      //   this.modifyRecipeFunc({
      //     orderId: this.$store.state.prvateConsultation.orderId,
      //     prescriptionId: this.modifyRecipeID,
      //     medicine: medicineInfoList

      //   })
      //   // this.modifyRecipeID = ''
      //   return false
      // }


      var params = {
        orderId: this.$store.state.prvateConsultation.orderId,
        recipeId: this.confirmedObj.recipeId && this.confirmedObj.recipeId,
        medicineInfoList,
        fetchDrugTypeID: this.formItemDrugType.type
      }
      if (this.shop) {
        params.preHospitalGuid = this.shop
        params.preHospitalName = this.shopName
      }
      api
        .adminOnlineSendRecipe({
          data: {
            params: params
          }
        })
        .then(res => {
          //  console.log(res);
          if (res.code == '0') {
            if (res.data.state == 1) {
              this.showErrorModal = true
              this.errorList = res.data.list
            } else {
              // 清空输入位置列表
              this.inputData = [_.cloneDeep(this.baseData)]
              this.onlineRecipeList()
              this.modifyRecipeID = ''
            }
          }
          this.totalPriceFun()
          // this.totalPrice = '0.00'
        })

      this.showSaveModal = false
    },
    getShop () {
      api
        .getHospitalConfigInfo({
          data: {
            params: {
              hospital_guid: this.$store.state.auth.info.allHospitalGuid,
              config_id: "692"
            }
          }
        })
        .then(res => {
          if (res.code == 0) {
            this.yfArr = res.data.info
            if (res.data.info && res.data.info.length > 0) {
              this.shop = res.data.info[0].guid
              this.shopName = res.data.info[0].name
            }
          }
        })
    },
    modifyRecipeFunc (params) {
      api
        .editDiagnose({
          data: {
            params: params
          }
        })
        .then(res => {
          //  console.log(res);
          if (res.code == '0') {
            if (res.data.state == 1) {
              // this.showErrorModal = true
              this.errorList = res.data.list
            } else {
              // 清空输入位置列表
              this.inputData = [_.cloneDeep(this.baseData)]
              this.onlineRecipeList()
            }
          }
          this.totalPriceFun()
          // this.totalPrice = '0.00'
        })
    },
    // 跳转光标
    jumpFocus (index, name) {
      let domArr = []
      for (let i = 0; i < document.all.length; i++) {
        if (document.all[i].type == 'text') {
          domArr.push(document.all[i])
        }
      }
      for (let m = 0; m < domArr.length; m++) {
        if (
          domArr[m].dataset.index == index &&
          domArr[m].dataset.key === name
        ) {
          this.inputIndex = index
          domArr[m].focus()
          break
        }
      }
    },
    // 隐藏所有弹层
    closeAllPop () {
      this.showSuggestTab = false
      this.showSuggestPop = false
      this.showSuggestfrequenceCodeStringPop = false
    },
    // 计算合计金额
    totalPriceFun () {
      this.totalPrice = 0

      this.inputData.map(item => {
        item.map(childItem => {
          if (childItem.key == 'totalCost') {
            this.totalPrice += parseFloat(childItem.value || 0)
          }
        })
      })
      this.totalPrice = this.totalPrice.toFixed(2)
    },
    // 打印
    getStyle: function () {
      var str = "",
        styles = document.querySelectorAll('style,link');
      for (var i = 0; i < styles.length; i++) {
        str += styles[i].outerHTML;
      }
      return str;
    },
    print () {
      var w, doc, iframe = document.createElement('iframe'),
        f = document.body.appendChild(iframe);
      let codestr = '<html style="font-size: 30px;">' + document.querySelector('.right-header-info').outerHTML + document.querySelector('.show-prescription-wrap').outerHTML + this.getStyle() + '<style>.table-info{font-size: 12px !important}@page{size:landscape;}</style>' + '</html>'
      iframe.id = "myIframe";
      iframe.setAttribute('style', 'position:absolute;width:0;height:0;top:-10px;left:-10px;');
      w = f.contentWindow || f.contentDocument;
      doc = f.contentDocument || f.contentWindow.document;
      doc.open();
      doc.write(codestr);
      doc.close();
      var _this = this
      iframe.onload = function () {
        w.print();
        setTimeout(function () {
          document.body.removeChild(iframe)
        }, 100)
      }
    },
    // 初始化表格
    init (oldtempObj) {
      // 更新列表后会执行init 撤回后防止inputData清空
      let tempObj = oldtempObj && oldtempObj.length > 0 ? oldtempObj : [_.cloneDeep(this.baseData)]
      this.inputData = tempObj
      console.log(this.inputData)
    },
    getTemplateData () {
      var params = {
        templateType: "0",
        searchKey: this.searchKey,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        pslocation: this.shop,
        prescriptionType: 0
      }
      api
        .getTemplateList({
          data: {
            params: params
          }
        })
        .then(res => {
          if (res.code == 0) {
            console.log(res.data)
            this.templateArr = res.data.templateList
          }
        })
    },
    handleDrawerChange () {

    },
    hanldeTemple () {
      this.localVisible = true
      this.getTemplateData()
    },
    handleCheckAllGroup () {

    },
    handleCheckAll () {


    }
  },

  created () {
    this.init()
  },
  computed: {
    ...mapGetters({
      suggestdrugRouteStringDataCache: 'prvateConsultation/suggestdrugRouteStringDataCache',
      suggestfrequenceCodeStringDataCache: 'prvateConsultation/suggestfrequenceCodeStringDataCache',
      templateBtns: 'prvateConsultation/templateBtns'
    }),
    orderId () {
      return this.$store.state.prvateConsultation.orderId
    }
  },
  watch: {
    orderId: function (val) {
      this.onlineRecipeList()
      this.suggestTabDataGet()
    },
    templateBtns: function (val) {
      if (val.templateBtns.showMedicalTemplate == 1) {
        this.isshow = true
      } else {
        this.isshow = false
      }
    }
  }
}
</script>

<style scoped>
.prescription-wrap {
  width: 100%;
  height: 100%;
  font-size: 9px;
  color: #333333;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.show-prescription-wrap {
  height: 35vh;
  overflow-y: scroll;
}
.create-prescription-wrap {
  height: 30vh;
  position: relative;
  overflow-y: scroll;
}
.table-wrap .table-info {
  height: 20px;
  background: #ebebeb;
  padding: 2px 4px;
  line-height: 20px;
  display: flex;
  justify-content: space-between;
}
.table-wrap .table-info > div {
  width: 60px;
  height: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.table-wrap .table-info > div > div {
  width: 26px;
  height: 12px;
  background: #4aa5fe;
  border-radius: 2px;
  color: #fff;
  line-height: 12px;
  text-align: center;
  font-size: 8px;
  cursor: pointer;
}
.table-wrap .table-header,
.create-prescription-wrap .table-header {
  height: 20px;
  background: #fff;
  white-space: nowrap;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-top: 1px solid #ebebeb;
  /* margin-top: 0.5rem; */
}
.create-prescription-wrap .table-header {
  margin-top: 0.5rem;
}
.table-wrap .table-header > div,
.table-wrap .table-content > div,
.create-prescription-wrap .table-header > div,
.create-prescription-wrap .table-content > div {
  flex: 1;
  min-height: 20px;
  border-right: 1px solid #ebebeb;
  border-bottom: 1px solid #ebebeb;
  box-sizing: border-box;
  line-height: 20px;
  text-align: center;
  position: relative;
}
.table-wrap .table-content,
.create-prescription-wrap .table-content {
  display: flex;
  justify-content: flex-start;
  /* align-items: center; */
  align-items: stretch;
  position: relative;
  min-height: 20px;
  background: #fff;
}
.create-prescription-wrap .table-content input {
  width: 99%;
  height: 100%;
  border: none;
  text-align: center;
}
.create-prescription-wrap .table-content input:focus {
  outline: none;
}
.title-info {
  height: 20px;
  padding: 10px 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  line-height: 20px;
}
.title-info > div {
  width: 100px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.title-info > div > div {
  width: 45px;
  /* height: 18px; */
  background: #4aa5fe;
  border-radius: 4px;
  color: #fff;
  font-size: 10px;
  line-height: 18px;
  text-align: center;
  cursor: pointer;
  height: auto;
}
.title-shop {
  display: flex;
  justify-content: left;
  align-items: center;
  margin-top: 10px;
}
.title-shop .addshop {
  font-size: 12px;
  margin-right: 80px;
}
.print-wrap {
  justify-content: right !important;
}
.print-wrap > div {
  width: auto !important;
}
.print-wrap > div > div {
  background: #b4b8bc !important;
}
.title-info .drugtype {
  width: 60%;
  vertical-align: middle;
  display: inline-block;
  height: 0.5rem;
}
.drugtype-li {
  display: inline-block;
  vertical-align: middle;
  float: left;
  margin-right: 1rem;
}
.create-prescription-wrap .table-header .select-box,
.create-prescription-wrap .table-content .select-box {
  flex: 0 0 auto;
  width: 20px;
  height: 20px;
  border-left: 1px solid #ebebeb;
  border-top: 1px solid #ebebeb;
}
.create-prescription-wrap .table-content .select-box {
  border-top: none;
  display: flex;
  justify-content: center;
  align-items: center;
}
.create-prescription-wrap .table-content .select-box > input {
  width: 10px;
  height: 10px;
}
.create-prescription-wrap .table-content .suggest-table-wrap {
  height: 100px;
  overflow-y: auto;
  position: fixed;
  top: 0px;
  left: 0px;
  border: 1px solid #ebebeb;
  background: #fff;
  z-index: 9999;
}
.create-prescription-wrap .table-content .suggest-table-wrap .table-header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.create-prescription-wrap
  .table-content
  .suggest-table-wrap
  .table-header
  > div {
  width: 71.5px;
  height: 20px;
  line-height: 20px;
}
.create-prescription-wrap
  .table-content
  .suggest-table-wrap
  .table-content
  > div {
  width: 71.5px;
  min-height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  cursor: pointer;
}
.create-prescription-wrap .table-content .suggest-pop-wrap {
  position: absolute;
  width: 71.5px;
  height: 100px;
  overflow-y: auto;
  display: block;
  top: 0;
  left: 0;
  border: 1px solid #ebebeb;
  background: #fff;
}

.create-prescription-wrap .table-content .suggest-pop-wrap > div {
  cursor: pointer;
}
.create-prescription-wrap .total-price-style {
  width: 100%;
  text-align: right;
  margin-top: 5px;
}
input.dosage {
  display: inline-block;
  width: 71% !important;
  float: left;
}
.reason-p {
  color: #ff0000;
  line-height: 30px;
  padding-right: 1rem;
}
.status9 {
  color: #ff0000;
}
.modifyRecipe {
  background: #ff0000 !important;
}
.drugtypeModel .ivu-radio-group {
  display: block !important;
}
.drugtype-li span {
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
}
.radio-span {
  width: 0.4rem;
  height: 0.4rem;
  margin-right: 0.2rem;
  border-radius: 50%;
  border: 1px solid #72beff;
  cursor: pointer;
}
.drugtype-li.active .radio-span {
  background: #72beff;
  color: #72beff;
}
.suggest-table-relative {
  position: relative !important;
}
.suggest-table-absolute {
  position: absolute !important;
  top: 0.625rem !important;
  left: 0 !important;
  z-index: 9999;
}
.drugtypeshop {
  width: 80%;
  display: flex;
  align-items: center;
}
.muban {
  margin-bottom: 20px;
  text-align: center;
}
.checkbox-all {
  margin-left: 5px;
  display: inline-block;
  position: relative;
  z-index: 9;
}
.Drawer {
  margin: 10px;
}
.Drawer >>> .ivu-collapse {
  border: none !important;
  background: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/private_consultation_page/fun_right/prescription_page/index.vue